import { FormBase } from 'core/components';

export default class StatusChangeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'fulfillmentOrderStatusId',
					label: 'STATUSCHANGEVIEW.FULFILLMENTORDERSTATUS',
					rules: 'required',
				}
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/StatusChangeForm.js